﻿import DOMPurify, { type ElementHook } from 'dompurify';

export const getCleanHtmlString = (htmlString: string): string => {
  const forceLinkTargetBlank: ElementHook = (node) => {
    if ('target' in node) {
      node.setAttribute('target', '_blank');
      node.setAttribute('rel', 'noopener');
    }
  };

  DOMPurify.addHook('afterSanitizeAttributes', forceLinkTargetBlank);
  try {
    return DOMPurify.sanitize(htmlString);
  } finally {
    DOMPurify.removeHook('afterSanitizeAttributes', forceLinkTargetBlank);
  }
};
